<template>
  <div class="mobilePage" :class="{ ios: os.isPhone }">
    <div class="pageB">
      <div class="sceneStage" aria-hidden="true">
        <img
          class="sceneBase"
          src="@/assets/images/mobile1/pageB/bg.webp"
          alt=""
        />
        <img
          v-for="(item, index) in overlaySlides"
          :key="item"
          class="sceneSlide"
          :class="[`slide${index + 2}`, { active: activeIndex === index + 1 }]"
          :src="item"
          alt=""
        />
        <img
          class="sceneMedal"
          src="@/assets/images/mobile1/pageB/medal.webp"
          alt=""
        />
        <img
          class="mainCopy"
          src="@/assets/images/mobile1/pageB/copy.webp"
          alt=""
        />
        <img
          class="features"
          src="@/assets/images/mobile1/pageB/features.webp"
          alt=""
        />
      </div>
      <div class="header">
        <img
          src="@/assets/images/mobile1/pageB/logo.webp"
          alt=""
          class="logo"
        />
        <div class="contactBox">
          <img
            v-if="tgUrl"
            src="@/assets/images/mobile1/pageB/service-tg.webp"
            class="contactItem"
            @click="toPage(tgUrl)"
          />
          <img
            v-if="qdUrl"
            src="@/assets/images/mobile1/pageB/service-qd.webp"
            class="contactItem"
            @click="toPage(qdUrl)"
          />
          <img
            v-if="swUrl"
            src="@/assets/images/mobile1/pageB/service-sw.webp"
            class="contactItem"
            @click="toPage(swUrl)"
          />
        </div>
      </div>
      <div class="bottomBox">
        <img
          v-if="os.isPhone"
          class="downBtn"
          src="@/assets/images/mobile1/pageB/download-fast.webp"
          alt="极速下载"
          @click.stop="getApkInfo('ios', $event)"
        />
        <div
          v-else
          class="androidDownBox"
          :class="{ hasSpare: showSpareDownload }"
        >
          <button
            v-if="showSpareDownload"
            class="alternateDownloadBtn downBtn"
            type="button"
            @click.stop="getApkInfo('androidSpare', $event)"
          >
            <span class="downloadBolt">ϟ</span>
            备用下载
          </button>
          <img
            class="downBtn"
            src="@/assets/images/mobile1/pageB/download-fast.webp"
            alt="极速下载"
            @click.stop="getApkInfo('android', $event)"
          />
        </div>
      </div>
    </div>

    <!-- 安卓提示框 -->
    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <!-- 苹果提示框 -->
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div>
        <div class="overlayContent" @click.stop>
          <div class="appName">熟果短剧</div>
          <div class="desc">钻进被窝偷偷看好片</div>
          <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">
        请使用Safari浏览器进行下载
      </div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";
export default {
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      activeIndex: 0,
      slideTimer: null,
      overlaySlides: [
        require("@/assets/images/mobile1/pageB/slide2.webp"),
        require("@/assets/images/mobile1/pageB/slide3.webp")
      ],

      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: ""
    };
  },
  computed: {
    showSpareDownload() {
      const data = this.switchData || {};
      return Boolean(data.androidDownUrl && data.channelApkAndDownUrl);
    }
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
        return newValue;
      });
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
    const referrer = sessionStorage.getItem("referrer");
    const dc = sessionStorage.getItem("dc");
    if (referrer && dc) {
      this.currUrl = referrer + "user.html?dc=" + dc;
    } else {
      if (referrer) {
        this.currUrl = referrer + "user.html";
      } else {
        this.currUrl = window.location.href;
      }
    }
    // 预加载安装教程弹窗背景（藏在 display:none 的 overlay 里不会自动拉取），
    // 防止弹出时正赶上下载跳转被中断
    new Image().src = require("@/assets/images/mobile1/iosTip.png");
    new Image().src = require("@/assets/images/mobile1/android_tip.png");
    this.startRotation();
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
    // 剪贴板
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => {}
      );
    },
    checkIsSafari() {
      let ua = this.os.userAgent.toLowerCase();
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      const data = this.switchData || {};
      const isIos = this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.getApkInfo(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type == "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async getApkInfo(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      this.$emit("recordClick", type);
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      let click_coordinates_x = event.clientX;
      let click_coordinates_y = event.clientY;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x,
        click_coordinates_y
      });
    },
    startRotation() {
      this.stopRotation();
      this.slideTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % 3;
      }, 3500);
    },
    stopRotation() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer);
        this.slideTimer = null;
      }
    },
    toPage(path) {
      window.open(path);
    }
  }
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.mobilePage {
  height: 100%;
  width: 100%;
  .pageB {
    width: 100%;
    min-height: 100%;
    height: 100dvh;
    background: #000;
    overflow: hidden;
    position: relative;
    .sceneStage {
      position: absolute;
      inset: 0;
      z-index: 0;
      overflow: hidden;
      pointer-events: none;
    }
    .sceneBase {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
    }
    .sceneSlide {
      position: absolute;
      z-index: 10;
      opacity: 0;
      transition: opacity 0.8s ease;
      &.active {
        opacity: 1;
      }
      &.slide2 {
        left: -6.2%;
        top: -1.56%;
        width: 102.17%;
        height: 54.61%;
      }
      &.slide3 {
        left: -6.6%;
        top: -0.82%;
        width: 102.39%;
        height: 53.76%;
      }
    }
    .sceneMedal {
      position: absolute;
      left: 6.73%;
      top: 6.89%;
      z-index: 20;
      width: 24.27%;
      height: 12.41%;
    }
    .mainCopy {
      position: absolute;
      left: 0.25%;
      top: 50.31%;
      z-index: 30;
      width: 99.68%;
      height: 24.98%;
    }
    .features {
      position: absolute;
      left: 0;
      top: 74.67%;
      z-index: 30;
      width: 100%;
      height: 7.16%;
    }
    .header {
      display: flex;
      padding: calc(8px + env(safe-area-inset-top)) 14.5px 0;
      justify-content: space-between;
      align-items: flex-start;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 120;
      box-sizing: border-box;
    }
    .logo {
      width: 129.7px;
      height: auto;
    }
    .contactBox {
      margin-top: -10px;
      display: flex;
      align-items: flex-end;
      gap: 24px;
      .contactItem {
        width: 34px;
        height: auto;
        cursor: pointer;
      }
    }
    .bottomBox {
      z-index: 100;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: max(10.2dvh, calc(24px + env(safe-area-inset-bottom)));
      display: flex;
      align-items: center;
      justify-content: center;
      .downBtn {
        display: block;
        width: 232.5px;
        height: 55.5px;
        cursor: pointer;
      }
      .androidDownBox {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        &.hasSpare .downBtn {
          width: 164px;
          height: 39.15px;
        }
        .alternateDownloadBtn {
          box-sizing: border-box;
          border: 2px solid #f6c35c;
          border-radius: 12px;
          background: linear-gradient(180deg, #ffe5a2 0%, #eca52e 100%);
          box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.62),
            0 0 10px rgba(242, 174, 52, 0.85);
          color: #0b0802;
          font-size: 18px;
          font-weight: 700;
          letter-spacing: 2px;
          white-space: nowrap;
          .downloadBolt {
            margin-right: 4px;
            font-size: 22px;
          }
        }
      }
    }
  }
  .androidOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/android_tip.png")
        no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }

  .iosOverlay {
    display: flex;
    align-items: center;
    justify-content: center;

    .overlayContent {
      width: 297px;
      height: 441px;
      background: url("./../../../assets/images/mobile1/iosTip.png") no-repeat;
      background-size: 100% 100%;
      border-radius: 12px;
      padding-top: 380px;
      position: relative;

      .appName {
        font-size: 10px;
        font-weight: 500;
        color: #242423;
        position: absolute;
        left: 79px;
        bottom: 102px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .desc {
        font-size: 7px;
        font-weight: 500;
        color: #8f908f;
        position: absolute;
        left: 79px;
        bottom: 92px;
        z-index: 1;
        background-color: #ffffff;
        width: 100px;
      }

      .confirmBtnBox {
        height: 36px;
        width: 140px;
        border-radius: 40px;
        margin: 0 auto;
      }
    }
  }
}

.downTip {
  border-radius: 10px;
  padding: 18px;
  box-sizing: border-box;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent {
    white-space: nowrap;
    font-size: 15px;
  }

  .url {
    font-size: 15px;
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    font-size: 15px;
    width: 160px;
    height: 30px;
    border-radius: 40px;
    margin: 32px auto 0;
    color: #fff;
    background: #5b92ee;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
